import Container from 'react-bootstrap/Container'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Image from 'react-bootstrap/Image'
import EarthIcon from '../../../assets/icons/common/earth.svg'
import FriendsIcon from '../../../assets/icons/common/friends.svg'
import StarIcon from '../../../assets/icons/common/star.svg'
import './about.css'

function AboutUS({ data }) {
  const highlights = [
    {
      icon: EarthIcon,
      title: 'Healthy Living',
      text: 'Product-first wellness values built around everyday family use.',
    },
    {
      icon: FriendsIcon,
      title: 'Fair Earning',
      text: 'A member network designed around community and repeat growth.',
    },
    {
      icon: StarIcon,
      title: 'Trusted Brand',
      text: 'Clear company identity with legal documents and public presence.',
    },
  ]

  return (
    <section className='ag-about-section'>
      <Container>
        <Row className='align-items-center g-4 g-lg-5'>
          <Col lg={5}>
            <div className='ag-about-section__points'>
              <div className='ag-about-section__brand-card'>
                <span>AGC</span>
                <strong>Change Theory - Gain Ownership</strong>
                <p>Built around wellness products, member trust, and fair earning.</p>
              </div>

              {highlights.map((item) => (
                <div className='ag-about-section__highlight' key={item.title}>
                  <div className='ag-about-section__icon'>
                    <Image src={item.icon} alt='' />
                  </div>
                  <div>
                    <h3>{item.title}</h3>
                    <span>{item.text}</span>
                  </div>
                </div>
              ))}
            </div>
          </Col>

          <Col lg={7}>
            <div className='ag-about-section__content'>
              <span className='ag-about-section__eyebrow'>About Actual Green</span>
              <h2>{data?.title}</h2>
              <p>{data?.content}</p>

              <div className='ag-about-section__statement'>
                <strong>Actual Green Corporation</strong>
                <span>
                  A product-led MLM platform focused on healthier living,
                  transparent company presence, and sustainable member growth.
                </span>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  )
}

export default AboutUS
